import { Component, EventEmitter, Input, Output } from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldAppearance, MatFormFieldModule} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

type Position = 'right' | 'left'

@Component({
  selector: 'app-search-bar-component',
  imports: [MatInputModule, MatFormFieldModule, MatIcon, MatButton],
  templateUrl: './search-bar-component.html',
  styleUrl: './search-bar-component.css',
})
export class SearchBarComponent {

  @Output() searchBarValue = new EventEmitter<string>();
  @Input() appearance : MatFormFieldAppearance = 'outline'
  @Input() width : number = 100
  @Input() position : Position = 'right'


  getValue(event: Event){
    const value = (event.target as HTMLInputElement).value;
    this.searchBarValue.emit(value)
  }

  resetValue(input : HTMLInputElement){
    input.value = ""
    this.searchBarValue.emit('')
  }
}
